import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from 'app/App';
import reportWebVitals from './reportWebVitals';
import StripeProvider from 'app/StripeProvider';
import { ThemeProvider } from 'contexts/ThemeContext';
import { CookieConsentProvider } from 'contexts/CookieConsentContext';
import { initializeAnalytics, setAnalyticsConsent } from 'services/analyticsService';

import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

const CONSENT_KEY = 'cookie_consent';
const hasConsent = localStorage.getItem(CONSENT_KEY) === 'accepted';
setAnalyticsConsent(hasConsent);

const customTheme = createTheme({
  palette: {
    primary: {
      main: '#ff5a36',
    },
    secondary: {
      main: '#DC2A04',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <MuiThemeProvider theme={customTheme}>
    <React.StrictMode>
      <CookieConsentProvider>
        <StripeProvider>
          <App />
        </StripeProvider>
      </CookieConsentProvider>
    </React.StrictMode>
    </MuiThemeProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const startAnalytics = () => {
  const load = () => initializeAnalytics().catch(() => {});

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(load, { timeout: 5000 });
  } else {
    window.setTimeout(load, 0);
  }
};

if (document.readyState === 'complete') {
  startAnalytics();
} else {
  window.addEventListener('load', startAnalytics, { once: true });
}
